import React from 'react';
import patterns from '@/shared/ui/styles/patterns.module.css';
import type { AuditEventType } from '../api/auditApi';
import styles from '../pages/AgencyAuditLogPage.module.css';
import { EVENT_LABELS } from './auditFormat';

const EVENT_PILL_CLASS: Record<AuditEventType, string> = {
  login: patterns.pillSuccess,
  login_failed: patterns.pillError,
  logout: patterns.pillMuted,
  page_view: patterns.pillInfo,
  impersonation: patterns.pillWarning,
  feature_flag_change: patterns.pillAccent,
  comms_preference_change: patterns.pillAccent,
  skill_change_proposed: patterns.pillAccent,
  skill_override_change: patterns.pillAccent,
  notebook_change: patterns.pillWarning,
  texting_setup_change: patterns.pillAccent,
  tracked_link_change: patterns.pillAccent,
};

export function EventPill({ eventType }: { eventType: AuditEventType }) {
  return (
    <span className={`${patterns.pill} ${EVENT_PILL_CLASS[eventType]}`}>
      {EVENT_LABELS[eventType]}
    </span>
  );
}

/**
 * Highlights every occurrence of the search term inside a value, so a hit on
 * an IP address or a path is visible without the reader hunting for it.
 * Falls back to plain text when there is no term.
 */
export function Highlight({ text, term }: { text: string; term: string }) {
  const needle = term.trim();
  if (!needle) return <>{text}</>;

  const parts: React.ReactNode[] = [];
  const lowerText = text.toLowerCase();
  const lowerNeedle = needle.toLowerCase();

  let cursor = 0;
  let match = lowerText.indexOf(lowerNeedle);
  while (match !== -1) {
    if (match > cursor) parts.push(text.slice(cursor, match));
    parts.push(
      <mark key={`${match}-${parts.length}`} className={styles.mark}>
        {text.slice(match, match + needle.length)}
      </mark>,
    );
    cursor = match + needle.length;
    match = lowerText.indexOf(lowerNeedle, cursor);
  }
  if (cursor < text.length) parts.push(text.slice(cursor));

  return <>{parts}</>;
}
